module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('arizona-map', {
    attrs: {
      "mapFile": "az.counties.json",
      "dataFile": "az_load.csv",
      "res": "Lake Havasu",
      "resFile": "az.json",
      "whichState": "AZ"
    }
  }), _vm._v(" "), _c('snow-chart', {
    attrs: {
      "whichState": "AZ"
    }
  }), _vm._v(" "), _c('drought-map', {
    attrs: {
      "mapFile": "az.counties.json",
      "centersFile": "az_centers.json",
      "dataFile": "az-counties.csv"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b98142da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Arizona.vue
// module id = 382
// module chunks = 1